/* eslint-disable no-console */
import { goToPhoneValidation } from '@/navigation/CSR/goToPhoneValidation'
import { AppRouterInstance } from 'next/dist/shared/lib/app-router-context.shared-runtime'

/**
 * Handles phone validation enforcement errors
 * @param router - Next.js app router instance
 */
export const handlePhoneValidationError = (router: AppRouterInstance): void => {
  console.log('↔ ~ HANDLE Error: ENFORCE_CUSTOMER_PHONE_VALIDATION_FAILED')
  goToPhoneValidation(router)
}
